<template>
    <basic-card>
        <template slot="header">
            {{$t('reconciliation.reconciliationItems')}}
        </template>
        <simple-list :columns="columns" object-name="reconciliationMatch"
                     query-store-name="reconciliation"/>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import SimpleList from "../components/lists/SimpleList";

    export default {
        name: "ReconciliationItemsView",
        components: {SimpleList, BasicCard},
        data() {
            return {
                columns: [
                    {
                        caption: "Id",
                        datum: d => d.id
                    },
                    {
                        caption: this.$t('type'),
                        datum: d => d.type
                    },
                    {
                        caption: this.$t('accountBalancesItems.accountBalancesItem'),
                        datum: d => d.exactMatchList[0].id
                    },
                    {
                        caption:  this.$t('reconciliation.operation'),
                        datum: d => d.cashEventDto.operationId
                    },
                    {
                        caption:  this.$t('accountBalancesItems.amount'),
                        datum: d => this.$formats.formatAmount(d.cashEventDto.amount / 1000000)
                    },
                    {
                        caption: this.$t('accounts.currency'),
                        datum: d => d.cashEventDto.currency
                    },
                    {
                        caption: this.$t('reconciliation.originalDate'),
                        datum: d => this.$formats.formatDate(d.cashEventDto.date, false)
                    },
                    {
                        caption: this.$t('reconciliation.realizationDate'),
                        datum: d => this.$formats.formatDate(d.exactMatchList[0].accountBalanceDate, false)
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>